import { render, staticRenderFns } from "./Portais.vue?vue&type=template&id=13948491"
import script from "./Portais.vue?vue&type=script&lang=js"
export * from "./Portais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports